module.exports = __webpack_public_path__ + "static/img/Post shore 1,2,3 meter.f46c70e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Post shore 1,2,3 meter.jpg
// module id = 93
// module chunks = 1